import(/* webpackMode: "eager", webpackExports: ["HomePageBackground"] */ "/home/iktravels/domains/website/src/components/HomePageBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IKDownloadApp"] */ "/home/iktravels/domains/website/src/components/IKDownloadApp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IKFAQ"] */ "/home/iktravels/domains/website/src/components/IKFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IKFooter"] */ "/home/iktravels/domains/website/src/components/IKFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IKHowItWorks"] */ "/home/iktravels/domains/website/src/components/IKHowItWorks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IKPopularCars"] */ "/home/iktravels/domains/website/src/components/IKPopularCars.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IKTestimonials"] */ "/home/iktravels/domains/website/src/components/IKTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IKTravelHero"] */ "/home/iktravels/domains/website/src/components/IKTravelHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IKTrendingOffers"] */ "/home/iktravels/domains/website/src/components/IKTrendingOffers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IKWhyChoose"] */ "/home/iktravels/domains/website/src/components/IKWhyChoose.tsx");
